export enum FacetedSearch {
  NAME = 'faceted_search_slp_experiment',
  CONTROL_STANDARD_SEARCH = 'control',
  VARIANT_FACETED_SEARCH = 'variant',
}

// This feature flag, for toggling the navigation tile, re-uses the original experiment for toggling the advent calendar navigation tile
export enum NavigationTile {
  NAME = 'advent_calendar_tile_slp_experiment',
  CONTROL_NO_TILES = 'control_no_tiles',
  VARIANT_SHOW_TILES = 'variant_show_tiles',
}

export enum FacilitateFindability {
  NAME = 'facilitate_findability_of_products_experiment',
  CONTROL_HIDE_FEATURED_PRODUCT = 'control_hide_featured_product',
  VARIANT_SHOW_FEATURED_PRODUCT = 'variant_show_featured_product',
}

export enum SearchProvider {
  NAME = 'search_provider',
  GOOGLE = 'google_retail',
  LOOP54 = 'loop54',
}
